import { render, staticRenderFns } from "./ImportLogTable.vue?vue&type=template&id=9c28e1bc"
import script from "./ImportLogTable.vue?vue&type=script&lang=js"
export * from "./ImportLogTable.vue?vue&type=script&lang=js"
import style0 from "./ImportLogTable.vue?vue&type=style&index=0&id=9c28e1bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports